module.exports = __webpack_public_path__ + "img/suppliers-upgrade-to-premium.98fa3151.svg";